module.exports = {"updown_read_key":"ro-HeJ8jt5Tm9yDHVmHq4p7\n","twitter":"datajoe","website_name":"DataJoe.com","website_url":"https://datajoe.com","logo_url":"https://www.datajoe.com/user/pages/images/logo.jpg"}


//////////////////
// WEBPACK FOOTER
// ./page_config.json
// module id = Yr1l
// module chunks = 1